import { useEffect, useState } from 'react';
import { DashboardLayout } from '../../components/DashboardLayout';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../components/ui/select';
import { MapPin, Filter } from 'lucide-react';
import api from '../../services/api';
import AgedReceivablesTab from './billing/AgedReceivablesTab';

/**
 * Aged Receivables — standalone report under Billing & Payments.
 *
 * Moved out of the Billing Overview tab set (iter387). This report is
 * intentionally all-time ("everything still owed, as of today, all
 * years"), so it exposes only a LOCATION filter — no time-based filters.
 */
const AgedReceivablesPage = () => {
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState('all');

  useEffect(() => {
    api.get('/locations/active').then((r) => setLocations(r.data || [])).catch(() => {});
  }, []);

  return (
    <DashboardLayout title="Aged Receivables">
      <div className="space-y-4" data-testid="aged-receivables-page">
        {/* Location-only filter bar (no time filters — A/R is all-time). */}
        <div className="flex flex-wrap items-center gap-3">
          <p className="text-slate-600 mr-2">
            Everything still owed, as of today, across all years
          </p>
          {locations.length > 0 && (
            <div className="flex items-center gap-2">
              <MapPin className="h-4 w-4 text-slate-400" />
              <Select value={selectedLocation} onValueChange={setSelectedLocation}>
                <SelectTrigger className="w-48" data-testid="aged-ar-location-filter">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">
                    <span className="flex items-center gap-2">
                      <Filter className="h-3 w-3" />
                      All Locations
                    </span>
                  </SelectItem>
                  {locations.map((loc) => (
                    <SelectItem key={loc.id} value={loc.id}>
                      {loc.name} {loc.is_primary && '(Primary)'}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}
        </div>

        {/* No dateRange prop → the report runs all-time by design. */}
        <AgedReceivablesTab locationId={selectedLocation} />
      </div>
    </DashboardLayout>
  );
};

export default AgedReceivablesPage;
